<script>
import ModalInstructorComponent from '../../features/modals/ModalInstructorComponent';
export default {
  name: 'ModalInstructorView',
  extends: ModalInstructorComponent,
};
</script>

<template>
  <el-dialog
    v-model="conf.isVisible"
    title="Profesor"
    width="35%"
    class="instructor-modal"
    append-to-body
    :before-close="onCancel"
    :close-on-click-modal="false"
  >
    <el-form
      ref="formData"
      v-loading="conf.isLoading"
      :model="formData"
      :rules="rules"
      status-icon
      :label-position="'top'"
    >
      <el-tabs v-model="activeName">
        <el-tab-pane
          label="CUENTA"
          name="account"
        >
          <fieldset>
            <legend>Información de Cuenta</legend>
            <br>
            <el-row
              class="row-bg"
              :gutter="10"
            >
              <el-col :span="24">
                <div class="img148">
                  <el-upload
                    action
                    :show-file-list="false"
                    :on-success="onSuccessHandlerProfilePicture"
                    :before-upload="onBeforeUploadHandlerProfilePicture"
                  >
                    <img
                      v-if="profileImageUrl"
                      :src="profileImageUrl"
                      class="avatar"
                    >
                    <i
                      v-else
                      class="el-icon-plus avatar-uploader-icon"
                    />
                  </el-upload>
                  <!-- <img src="/images/left-imgs/img-1.jpg" alt="" /> -->
                </div>
              </el-col>
            </el-row>
            <el-row
              v-if="showStatus"
              class="row-bg"
              :gutter="10"
            >
              <el-col
                :span="24"
                align="center"
              >
                <el-form-item
                  label="Estado"
                  prop="status"
                >
                  <el-switch
                    v-model="formData.userProfile.status"
                    style="display: block"
                    active-color="#13ce66"
                    inactive-text="Inactivo"
                    active-text="Activo"
                    :inactive-value="1"
                    :active-value="2"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row
              class="row-bg"
              :gutter="10"
            >
              <el-col
                :xs="24"
                :sm="12"
                :md="12"
                :lg="12"
                :xl="12"
              >
                <el-form-item
                  label="Usuario"
                  prop="userProfile.userName"
                >
                  <el-input
                    v-model="formData.userProfile.userName"
                    size="small"
                  />
                </el-form-item>
              </el-col>
              <el-col
                :xs="24"
                :sm="12"
                :md="12"
                :lg="12"
                :xl="12"
              >
                <el-form-item
                  label="Correo Electronico"
                  prop="userProfile.email"
                >
                  <el-input
                    v-model="formData.userProfile.email"
                    size="small"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row
              type="flex"
              class="row-bg"
              :gutter="20"
            >
              <el-col
                v-if="formData.id"
                :span="24"
              >
                <el-checkbox v-model="updatePassword">
                  Actualizar password
                </el-checkbox>
              </el-col>
            </el-row>
            <el-row
              v-if="!formData.id || updatePassword"
              class="row-bg"
              :gutter="20"
            >
              <el-col
                :xs="24"
                :sm="12"
                :md="12"
                :lg="12"
                :xl="12"
              >
                <el-form-item
                  label="Contraseña:"
                  prop="userProfile.password"
                >
                  <el-input
                    v-model="formData.userProfile.password"
                    size="small"
                    type="password"
                    placeholder="Contraseña"
                    :disabled="!isPasswordRequired()"
                  />
                </el-form-item>
              </el-col>
              <el-col
                :xs="24"
                :sm="12"
                :md="12"
                :lg="12"
                :xl="12"
              >
                <el-form-item
                  label="Verificar Contraseña:"
                  prop="userProfile.checkPass"
                >
                  <el-input
                    v-model="formData.userProfile.checkPass"
                    size="small"
                    type="password"
                    placeholder="Verificar Contraseña"
                    :disabled="!isPasswordRequired()"
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </fieldset>
        </el-tab-pane>
        <el-tab-pane
          label="INFORMACIÓN PERSONAL"
          name="personal"
        >
          <fieldset>
            <legend>Información Personal</legend>
            <el-row
              class="row-bg"
              :gutter="20"
            >
              <el-col
                :xs="24"
                :sm="12"
                :md="12"
                :lg="12"
                :xl="12"
              >
                <el-form-item
                  label="Nombre(s)"
                  prop="userProfile.firstName"
                >
                  <el-input
                    v-model="formData.userProfile.firstName"
                    maxlength="70"
                    size="small"
                  />
                </el-form-item>
              </el-col>
              <el-col
                :xs="24"
                :sm="12"
                :md="12"
                :lg="12"
                :xl="12"
              >
                <el-form-item
                  label="Apellido(s)"
                  prop="userProfile.lastName"
                >
                  <el-input
                    v-model="formData.userProfile.lastName"
                    maxlength="70"
                    size="small"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row
              type="flex"
              class="row-bg"
              :gutter="20"
            >
              <el-col :span="24">
                <el-form-item
                  label="Acerca de mi"
                  prop="about"
                >
                  <el-input
                    v-model="formData.about"
                    type="textarea"
                    :rows="3"
                    maxlength="255"
                    size="small"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row
              type="flex"
              class="row-bg"
              :gutter="20"
            >
              <el-col :span="24">
                <el-form-item
                  label="Especialidades o Áreas Educativas"
                  prop="educationSpecialty"
                >
                  <el-input
                    v-model="formData.educationSpecialty"
                    type="textarea"
                    :rows="3"
                    maxlength="255"
                    size="small"
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </fieldset>
        </el-tab-pane>
        <el-tab-pane
          label="CONTACTO"
          name="academic"
        >
          <fieldset>
            <legend>Información de Contacto</legend>
            <el-row
              type="flex"
              class="row-bg"
              :gutter="20"
            >
              <el-col :span="24">
                <el-form-item
                  label="Página de Facebook"
                  prop="pageUrlFacebook"
                >
                  <el-input
                    v-model="formData.pageUrlFacebook"
                    size="small"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row
              type="flex"
              class="row-bg"
              :gutter="20"
            >
              <el-col :span="24">
                <el-form-item
                  label="Página de Instagram"
                  prop="pageUrlInstagram"
                >
                  <el-input
                    v-model="formData.pageUrlInstagram"
                    size="small"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row
              type="flex"
              class="row-bg"
              :gutter="20"
            >
              <el-col :span="24">
                <el-form-item
                  label="Página de Linkedin"
                  prop="pageUrlLinkedIn"
                >
                  <el-input
                    v-model="formData.pageUrlLinkedIn"
                    size="small"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row
              class="row-bg"
              :gutter="20"
            >
              <el-col
                :xs="24"
                :sm="12"
                :md="12"
                :lg="12"
                :xl="12"
              >
                <el-form-item
                  label="Teléfono de Hogar"
                  prop="homePhone"
                >
                  <el-input
                    v-model.number="formData.homePhone"
                    size="small"
                  />
                </el-form-item>
              </el-col>
              <el-col
                :xs="24"
                :sm="12"
                :md="12"
                :lg="12"
                :xl="12"
              >
                <el-form-item
                  label="Teléfono Celular"
                  prop="cellPhone"
                >
                  <el-input
                    v-model.number="formData.cellPhone"
                    size="small"
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </fieldset>
        </el-tab-pane>
      </el-tabs>
    </el-form>
    <template #footer>
      <span class="dialog-footer">
        <el-button
          size="small"
          class="btn-cancel"
          @click="onCancel"
        >Cancelar</el-button>
        <el-button
          type="primary"
          :disabled="!onCanSaveOrUpdate()"
          class="btn-primary"
          size="small"
          @click="onSubmitForm('formData')"
        >Guardar</el-button>
      </span>
    </template>
  </el-dialog>
</template>
